// test1176
(1176 && 0);
